import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Spinner from "../../Components/spinner/spinner";
import useInventoryManagement from "./hooks/useInventoryManagement";
import { useEffect, useState } from "react";
import Paginations from "../../Components/Pagination/pagination";

const UpdateInventory = () => {
    const navigate = useNavigate();
    const [tab, setTab] = useState('INVENTORY-LIST');
    const { id } = useParams();
    const {
        spinner,
        inventoryFormik,
        categoryFullList,
        vendorFullList,
        inventoryDetails,
        stockList,
        PER_PAGE,
        pageHistory,
        historyCount,
        setPageHistroy,
        updateInventory,
    } = useInventoryManagement()

    const units = [
        { value: 'Strip', label: 'Strip' },
        { value: 'Bottle', label: 'Bottle' },
        { value: 'Box', label: 'Box' },
        { value: 'Pack', label: 'Pack' },
        { value: 'Other', label: 'Other' },
    ]

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    }

    // Initialize formik values when inventoryDetails changes
    useEffect(() => {
        if (inventoryDetails && Object.keys(inventoryDetails).length > 0) {
            inventoryFormik.setValues({
                productName: inventoryDetails.productName || "",
                category: inventoryDetails.category || "",
                brand: inventoryDetails.brand || "",
                unit: inventoryDetails.unit || "",
                expireDate: formatDateForInput(inventoryDetails.expireDate) || "",
                mrp: inventoryDetails.mrp || "",
                purchasePrice: inventoryDetails.purchasePrice || "",
                stockQuantity: inventoryDetails.stockQuantity || "",
                reorderLevel: inventoryDetails.reorderLevel || "",
                vendor: inventoryDetails.vendor || ""
            });
        }
    }, [inventoryDetails]);

    const handleSubmit = (e) => {
        e.preventDefault();
        updateInventory(id, inventoryFormik.values); // Pass the formik values to update function
    }

    console.log(historyCount, 'historyCount', PER_PAGE, 'PER_PAGE')

    return (
        <section>
            <ToastContainer />
            <div className="m-t-3 cus-padd cusheight">
                {spinner && <Spinner />}
                <header>
                    <h2 className='page-tittle'>
                        <i
                            className="fa-solid fa-angle-left cusgap cursor"
                            onClick={() => { navigate(-1) }}
                        ></i>
                        Inventory Management
                    </h2>
                    <hr />
                </header>
                <nav className="mb-3">
                    <div className="nav tabber" id="nav-tab" role="tablist">
                        <button
                            className={` ${tab === 'INVENTORY-LIST' ? 'activeNav' : 'unActiveNav'} border-0`}
                            type="button"
                            onClick={() => setTab('INVENTORY-LIST')}
                        >
                            Inventory
                        </button>
                        <button
                            className={` ${tab === 'INVENTORY-HISTORY' ? 'activeNav' : 'unActiveNav'} border-0`}
                            type="button"
                            onClick={() => setTab('INVENTORY-HISTORY')}
                        >
                            History
                        </button>
                    </div>
                </nav>
               <hr />
                {tab === 'INVENTORY-LIST' &&
                    <form className="row ps-4 cus-form mt-4" onSubmit={handleSubmit}>
                        <div className="py-3 mb-3 rounded row">
                            <div className="col-md-6 mt-2">
                                <label className="form-label">Product Id *</label>
                                <input disabled
                                    type="text"
                                    className="form-control alreadytext"
                                    value={inventoryDetails.productId || ''}
                                />
                            </div>

                            {/* Product Name */}
                            <div className="col-md-6 mt-2">
                                <label className="form-label">Product Name *</label>
                                <input
                                    type="text"
                                    name="productName"
                                    className={`form-control alreadytext ${inventoryFormik.touched.productName && inventoryFormik.errors.productName ? 'is-invalid' : ''
                                        }`}
                                    onChange={inventoryFormik.handleChange}
                                    onBlur={inventoryFormik.handleBlur}
                                    value={inventoryFormik.values.productName}
                                />
                                {inventoryFormik.touched.productName && inventoryFormik.errors.productName && (
                                    <div className="invalid-feedback">{inventoryFormik.errors.productName}</div>
                                )}
                            </div>

                            {/* Category */}
                            <div className="col-md-6 mt-2">
                                <label className="form-label">Category *</label>
                                <select
                                    className={`form-select form-control ${inventoryFormik.touched.category && inventoryFormik.errors.category ? 'is-invalid' : ''}`}
                                    aria-label="Default select example"
                                    name="category"
                                    onChange={inventoryFormik.handleChange}
                                    onBlur={inventoryFormik.handleBlur}
                                    value={inventoryFormik.values.category}
                                >
                                    <option value='' hidden>Select Category</option>
                                    {categoryFullList.map((item) => (
                                        <option value={item._id} key={item._id}>
                                            {item?.name}
                                        </option>
                                    ))}
                                </select>
                                {inventoryFormik.touched.category && inventoryFormik.errors.category && (
                                    <div className="invalid-feedback">{inventoryFormik.errors.category}</div>
                                )}
                            </div>

                            {/* expire date */}
                            <div className="col-md-6 mt-2">
                                <label className="form-label">Expire Date *</label>
                                <input
                                    type="date"
                                    name="expireDate"
                                    className={`form-control alreadytext ${inventoryFormik.touched.expireDate && inventoryFormik.errors.expireDate ? 'is-invalid' : ''
                                        }`}
                                    onChange={inventoryFormik.handleChange}
                                    onBlur={inventoryFormik.handleBlur}
                                    value={inventoryFormik.values.expireDate}
                                />
                                {inventoryFormik.touched.expireDate && inventoryFormik.errors.expireDate && (
                                    <div className="invalid-feedback">{inventoryFormik.errors.expireDate}</div>
                                )}
                            </div>

                            {/* unit */}
                            <div className="col-md-6 mt-2">
                                <label className="form-label">Unit *</label>
                                <select
                                    className={`form-select form-control ${inventoryFormik.touched.unit && inventoryFormik.errors.unit ? 'is-invalid' : ''}`}
                                    aria-label="Default select example"
                                    name="unit"
                                    onChange={inventoryFormik.handleChange}
                                    onBlur={inventoryFormik.handleBlur}
                                    value={inventoryFormik.values.unit}
                                >
                                    <option value='' hidden>Select Unit</option>
                                    {units.map((item) => (
                                        <option value={item.value} key={item.value}>
                                            {item?.label}
                                        </option>
                                    ))}
                                </select>
                                {inventoryFormik.touched.unit && inventoryFormik.errors.unit && (
                                    <div className="invalid-feedback">{inventoryFormik.errors.unit}</div>
                                )}
                            </div>

                            {/* Brand/Manufacture */}
                            <div className="col-md-6 mt-2">
                                <label className="form-label">Brand/Manufacture *</label>
                                <input
                                    type="text"
                                    name="brand"
                                    className={`form-control alreadytext ${inventoryFormik.touched.brand && inventoryFormik.errors.brand ? 'is-invalid' : ''
                                        }`}
                                    onChange={inventoryFormik.handleChange}
                                    onBlur={inventoryFormik.handleBlur}
                                    value={inventoryFormik.values.brand}
                                />
                                {inventoryFormik.touched.brand && inventoryFormik.errors.brand && (
                                    <div className="invalid-feedback">{inventoryFormik.errors.brand}</div>
                                )}
                            </div>

                            {/* Stock Quantity */}
                            <div className="col-md-6 mt-2">
                                <label className="form-label">Stock Quantity *</label>
                                <input
                                    type="number"
                                    name="stockQuantity"
                                    className={`form-control alreadytext ${inventoryFormik.touched.stockQuantity && inventoryFormik.errors.stockQuantity ? 'is-invalid' : ''
                                        }`}
                                    onChange={inventoryFormik.handleChange}
                                    onBlur={inventoryFormik.handleBlur}
                                    value={inventoryFormik.values.stockQuantity}
                                />
                                {inventoryFormik.touched.stockQuantity && inventoryFormik.errors.stockQuantity && (
                                    <div className="invalid-feedback">{inventoryFormik.errors.stockQuantity}</div>
                                )}
                            </div>

                            {/* MRP */}
                            <div className="col-md-6 mt-2">
                                <label className="form-label">MRP *</label>
                                <input
                                    type="number"
                                    name="mrp"
                                    className={`form-control alreadytext ${inventoryFormik.touched.mrp && inventoryFormik.errors.mrp ? 'is-invalid' : ''
                                        }`}
                                    onChange={inventoryFormik.handleChange}
                                    onBlur={inventoryFormik.handleBlur}
                                    value={inventoryFormik.values.mrp}
                                />
                                {inventoryFormik.touched.mrp && inventoryFormik.errors.mrp && (
                                    <div className="invalid-feedback">{inventoryFormik.errors.mrp}</div>
                                )}
                            </div>

                            {/* Re-order Level */}
                            <div className="col-md-6 mt-2">
                                <label className="form-label">Re-order Level *</label>
                                <input
                                    type="number"
                                    name="reorderLevel"
                                    className={`form-control alreadytext ${inventoryFormik.touched.reorderLevel && inventoryFormik.errors.reorderLevel ? 'is-invalid' : ''
                                        }`}
                                    onChange={inventoryFormik.handleChange}
                                    onBlur={inventoryFormik.handleBlur}
                                    value={inventoryFormik.values.reorderLevel}
                                />
                                {inventoryFormik.touched.reorderLevel && inventoryFormik.errors.reorderLevel && (
                                    <div className="invalid-feedback">{inventoryFormik.errors.reorderLevel}</div>
                                )}
                            </div>

                            {/* Purchase Price */}
                            <div className="col-md-6 mt-2">
                                <label className="form-label">Purchase Price *</label>
                                <input
                                    type="number"
                                    name="purchasePrice"
                                    className={`form-control alreadytext ${inventoryFormik.touched.purchasePrice && inventoryFormik.errors.purchasePrice ? 'is-invalid' : ''
                                        }`}
                                    onChange={inventoryFormik.handleChange}
                                    onBlur={inventoryFormik.handleBlur}
                                    value={inventoryFormik.values.purchasePrice}
                                />
                                {inventoryFormik.touched.purchasePrice && inventoryFormik.errors.purchasePrice && (
                                    <div className="invalid-feedback">{inventoryFormik.errors.purchasePrice}</div>
                                )}
                            </div>

                            {/* Vendor */}
                            <div className="col-md-6 mt-2">
                                <label className="form-label">Vendor *</label>
                                <select
                                    className={`form-select form-control ${inventoryFormik.touched.vendor && inventoryFormik.errors.vendor ? 'is-invalid' : ''}`}
                                    aria-label="Default select example"
                                    name="vendor"
                                    onChange={inventoryFormik.handleChange}
                                    onBlur={inventoryFormik.handleBlur}
                                    value={inventoryFormik.values.vendor}
                                >
                                    <option value='' hidden>Select Vendor</option>
                                    {vendorFullList.map((item) => (
                                        <option value={item._id} key={item._id}>
                                            {item?.name}
                                        </option>
                                    ))}
                                </select>
                                {inventoryFormik.touched.vendor && inventoryFormik.errors.vendor && (
                                    <div className="invalid-feedback">{inventoryFormik.errors.vendor}</div>
                                )}
                            </div>
                        </div>

                        <div className="d-flex justify-content-end" style={{ paddingRight: "50px" }}>
                            <button
                                type="submit"
                                className="btn yesbtn w-25"
                                disabled={inventoryFormik.isSubmitting}
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                }

                {tab === 'INVENTORY-HISTORY' &&
                    <div className="table-responsive" style={{ overflowX: 'hidden', paddingTop: '30px' }}>
                        {stockList.map((item) => (
                            <ul id={item._id} key={item._id} style={{ cursor: 'pointer', listStyle: 'none' }}>
                                <li className="readtable" style={{ paddingLeft: '30px', paddingBlock: '10px' }}> {item.status === 'ADD' ? 'Stock Added' : 'Stock Release'} : {item?.quantity}</li>
                            </ul>
                        ))}
                        <div className='w-100 d-flex justify-content-center'>
                            {
                                historyCount > 10 &&
                                <Paginations setpage={setPageHistroy} count={Math.ceil(historyCount / PER_PAGE)} page={pageHistory} />
                            }
                        </div>
                    </div>
                }
            </div>
        </section>
    );
};

export default UpdateInventory;